import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import {
  getFavoritos,
  postEliminarFavoritos,
} from "../../../actions/favoritos";
import FavoriteIcon from "@mui/icons-material/Favorite";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { CircularProgress, Tooltip, IconButton } from "@mui/material";
import { FavoritoRequest } from "../../../interface/favoritos/request";
import rutas from "../../../routes/constants/routes";

const MenuFavoritos = () => {
  const localSessionItem = window.localStorage.getItem("LocalSession");
  const local = localSessionItem ? JSON.parse(localSessionItem) : null;
  const history = useHistory();
  const dispatch = useDispatch();

  const { productosFavoritos, loading } = useSelector(
    (state: any) => state.favoritos,
  );

  const lista =
    productosFavoritos?.data?.$values ?? productosFavoritos?.data ?? [];

  useEffect(() => {
    const dropdown = document.getElementById("favoritosDropdown");

    const handler = () => {
      if (local?.clienteId && local?.contactoId) {
        dispatch(getFavoritos(local.clienteId.trim(), local.contactoId));
      }
    };

    dropdown?.addEventListener("show.bs.dropdown", handler);

    return () => {
      dropdown?.removeEventListener("show.bs.dropdown", handler);
    };
  }, []);

  const handleClick = (producto: any) => {
    history.push(`${rutas.DETALLES_PRODUCTO}/${producto.id.trim()}`);
  };

  const handleEliminar = (e: React.MouseEvent, productoId: string) => {
    e.stopPropagation();

    const request: FavoritoRequest = {
      clienteId: local.clienteId.trim(),
      contactoid: local.contactoId,
      productoId,
    };

    dispatch(postEliminarFavoritos(request));

    setTimeout(() => {
      dispatch(getFavoritos(local.clienteId.trim(), local.contactoId));
    }, 500);
  };

  return (
    <li className="nav-item dropdown my-auto" style={{ marginRight: "0.7rem" }}>
      <a
        className="nav-link dropdown-toggle"
        style={{ textDecoration: "none", color: "white", cursor: "pointer" }}
        id="favoritosDropdown"
        role="button"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        <Tooltip title="Mis favoritos">
          <FavoriteIcon
            fontSize="small"
            style={{ marginRight: "4px", verticalAlign: "middle" }}
          />
        </Tooltip>
        Favoritos
      </a>

      <ul
        className="dropdown-menu dropdown-menu-end"
        aria-labelledby="favoritosDropdown"
        style={{ width: "22vw", maxHeight: "60vh", overflowY: "auto" }}
      >
        {loading && (
          <li style={{ textAlign: "center", padding: "1rem" }}>
            <CircularProgress size={20} />
          </li>
        )}

        {!loading && lista.length === 0 && (
          <li
            style={{
              padding: "1rem",
              color: "#888",
              textAlign: "center",
              fontSize: "13px",
            }}
          >
            No tenés productos favoritos
          </li>
        )}

        {!loading &&
          lista.map((producto: any) => (
            <li
              key={producto.id}
              onClick={() => handleClick(producto)}
              style={{ cursor: "pointer" }}
            >
              <a className="dropdown-item" style={{ padding: "0.5rem 1rem" }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "0.75rem",
                  }}
                >
                  <img
                    src={producto.image || "/placeholder.png"}
                    alt={producto.descripcion}
                    style={{
                      width: "48px",
                      height: "48px",
                      objectFit: "contain",
                      flexShrink: 0,
                      borderRadius: "4px",
                      border: "1px solid #eee",
                    }}
                  />

                  {/* Info del producto */}
                  <div style={{ overflow: "hidden", flex: 1 }}>
                    <div
                      style={{
                        fontWeight: 600,
                        fontSize: "15px",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {producto.descripcion}
                    </div>
                    {producto.precio > 0 && (
                      <div
                        style={{
                          fontSize: "13px",
                          fontWeight: 500,
                          color: "#c0392b",
                        }}
                      >
                        {producto.simbolo}
                        {producto.precio.toLocaleString("es-AR")}
                      </div>
                    )}
                  </div>

                  {/* Botón eliminar */}
                  <Tooltip title="Quitar de favoritos">
                    <IconButton
                      size="small"
                      onClick={(e) => handleEliminar(e, producto.id)}
                      style={{ color: "#999", flexShrink: 0 }}
                      onMouseEnter={(e) =>
                        (e.currentTarget.style.color = "#c0392b")
                      }
                      onMouseLeave={(e) =>
                        (e.currentTarget.style.color = "#999")
                      }
                    >
                      <DeleteOutlineIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                </div>
              </a>
            </li>
          ))}

        {!loading && lista.length > 0 && (
          <li style={{ borderTop: "1px solid #eee", marginTop: "4px" }}>
            <Link
              className="dropdown-item"
              to="/favoritos"
              style={{ textAlign: "right", fontSize: "12px" }}
            >
              Ver todos →
            </Link>
          </li>
        )}
      </ul>
    </li>
  );
};

export default MenuFavoritos;
